// services/location/LocationFactory.ts
import type { Location } from './types'

export class LocationFactory {
  static createDefaultLocations(): Location[] {
    return [
      {
        default: 'berlin',
        geohash: 'u33db',
        name: 'Berlin',
        url: '/wetter/r/62422',
        dateAdded: Date.now(),
        visits: 0,
        lastVisit: Date.now(),
        fetchedPlace: null,
        lastFetchedPlace: null,
        fetchedCurrentConditions: null,
        lastFetchedCurrentConditions: null,
        timezoneOffset: null,
        localTime: null,
        timezone: 'Europe/Berlin',
      },
      {
        default: 'koeln',
        geohash: 'u1hcy',
        name: 'Köln',
        url: '/wetter/r/62578',
        dateAdded: Date.now(),
        visits: 0,
        lastVisit: Date.now(),
        fetchedPlace: null,
        lastFetchedPlace: null,
        fetchedCurrentConditions: null,
        lastFetchedCurrentConditions: null,
        timezoneOffset: null,
        localTime: null,
        timezone: 'Europe/Berlin',
      },
    ]
  }

  static createLocation(data: Partial<Location>): Location {
    return {
      ...data,
      geohash: data.geohash ?? '',
      name: data.name ?? '',
      url: data.url ?? '',
      dateAdded: Date.now(),
      lastVisit: Date.now(),
      visits: 0,
      fetchedPlace: data.fetchedPlace ?? null,
      lastFetchedPlace: data.lastFetchedPlace ?? null,
      fetchedCurrentConditions: data.fetchedCurrentConditions ?? null,
      lastFetchedCurrentConditions: data.lastFetchedCurrentConditions ?? null,
      timezoneOffset: data.timezoneOffset ?? null,
      localTime: data.localTime ?? null,
      timezone: data.timezone ?? null,
    }
  }
}
